import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import Title from '../Shared/Title';
import {
  submitSelectedEMEIConfirmation,
  closeModal,
  setSelectedIMEI,
  saveToHistory,
  errorDescriptionEnum,
  popUpEnum,
  setPopup,
  setSelectedPhoneNumber
} from '../IMEIDeviceRepairSlice';
import PopUp from '../../../Shared/Popup/PopUp';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import FindMyIphone from '../Popups/AlertPopUp';
import {
  dwhIDFIMEISelectionPageDisplay,
  dwhIMEIPageDisplay,
  dwhIMEISelectionPageDisplay,
  dwhPrivateErrorNoRepairServiceForDevice,
  dwhPrivateErrorNoRepairServiceForUser,
  dwhPrivateIMEIPageButtonClick,
  dwhPrivateIMEIPageDisplayed
} from '../reports/dwhReports';
import Config from '../../../../Config';
import {gtag4} from '../../../../utilities/analytics/tracking';
import SelectList from 'app/Components/Shared/SelectList/SelectList';
import HelpIcon from './../images/help-icon.svg';

const SubscriberSelection = (props) => {
  const [showIMEIError, setShowIMEIError] = useState(false);
  const {selectedPhoneNumber, selectedAccountOrgName, selectedIMEI } = props.deviceRepairData;
  const selectedHetPay = props.deviceRepairData.dwhData.selectedHetPay;
  const customerName = props.deviceRepairData.dwhData.customerName;
  const subscriber = props.deviceRepairData.dwhData.subscriber;
  const phone = props.deviceRepairData.selectedPhoneNumber;
  const multipleIMEIs = props.deviceRepairData.IMEIList.length > 1;

  useEffect(() => {
    props.saveToHistory('subscriber');
  }, []);

  const selectBoxObj = [];

  props.deviceRepairData.subscribers.map((subscriber) => {
    selectBoxObj.push({key: subscriber, value: subscriber});
  });

  const handleSelectIMEI = (e) => {
    props.setSelectedPhoneNumber(e);
  };

  const submitSelectedEMEIConfirmation = () => {
    if (!selectedPhoneNumber) {
      setShowIMEIError(true);
      return;
    }
    setShowIMEIError(false);
    let sendingData = {
      orgId: props.portalState.selectedHetPayId,
      startPoint: props.deviceRepairData.startPoint,
      selectedNumber: props.deviceRepairData.selectedPhoneNumber,
      isPrivate: props.deviceRepairData?.isPrivate,
      isFromPrivateSelfCare: props.contentData.isFromPrivateSelfcare.value == true
    };
    props.saveToHistory();
    props.submitSelectedEMEIConfirmation(sendingData);
  };

  const getBtnAction = () => {
    if (props.contentData.isFromPrivateSelfcare.value) {
      dwhPrivateIMEIPageButtonClick({selectedHetPay, subscriber, selectedIMEI, customerName, selectedAccountOrgName})
    }
    if (props.deviceRepairData.errorDescription == errorDescriptionEnum.WARR_ISSUR_IND) {
      return goToBusinessSelfcare();
    }
    return submitSelectedEMEIConfirmation();
  };

  const goToBusinessSelfcare = async () => {
    const content = await props.context.loadContentByPath(Config.businessLobbyUrl);
    props.context.navigateTo(content);
  };

  const getBtnText = () => {
    if (props.deviceRepairData.errorDescription === errorDescriptionEnum.WARR_ISSUR_IND) {
      return 'חזרה לאזור האישי';
    }
    return 'המשך';
  };


  return (
    <div className="imei-selection-wrapper">
      <Title text={'תאום שליחות לתיקון מכשיר'}
             subtext={"בחר את המנוי עבורו תתבצע השליחות"} />
      <div className="imei-selection-form">
        <SelectList options={selectBoxObj} onClick={(e) => handleSelectIMEI(e)} />
      </div>
      <div className="imei-select-submit">
        {showIMEIError && <span className={'cellcom-color'}>אנא בחר מנוי</span>}
        <BtnSubmit text={getBtnText()} onclick={() => getBtnAction()} />
      </div>

      <PopUp className={'imei-device-repair-popup'} showPopUp={props.deviceRepairData.isShowPopup}
             onClose={() => props.closeModal()}>
        <FindMyIphone />
      </PopUp>
    </div>
  )
};

const mapStateToProps = (state) => {
  return {
    deviceRepairData: state.iMEIDeviceRepair,
    portalState: state.portalsBlock,
    loginData: state.authentication.loginData
  };
};

const mapDispatchToProps = {submitSelectedEMEIConfirmation, closeModal, setSelectedIMEI, saveToHistory, setPopup, setSelectedPhoneNumber };

export default connect(mapStateToProps, mapDispatchToProps)(SubscriberSelection);
